import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { BuybackRestService } from "../buyback-rest.service";
import Swal from "sweetalert2";
import { BuybackListComponent } from "../list/buyback-list.component";
import { CommonService } from "../../../libraries/libraries.module";

@Component({
  selector: 'app-change-status-modal',
  templateUrl: 'change-status-modal.component.html',
  styleUrls: ['../buyback.component.scss']
})
export class ChangeStatusModalComponent {
  @Input() buyback: any;
  @Input() isOpen: boolean;
  @Output() onClose = new EventEmitter();

  
  constructor(
    private _BuybackRest: BuybackRestService,
    public _buybackListComponent: BuybackListComponent
  ) {
    this.initFormChangeStatus();
  }

  isLoading: boolean = false;
  formChangeStatus: FormGroup;
  
  initFormChangeStatus() {
    this.formChangeStatus = new FormGroup({
      statusDokumen: new FormControl('', [Validators.required])
    });
  }
  
  openDeliveryDateModal() {
    this.formChangeStatus.patchValue({
      statusDokumen: this.buyback?.statusDokumen
    });

    this.isOpen = true;
  }
  
  closeModal() {
    this.isOpen = false;
    this.formChangeStatus.reset();
    this.onClose.emit();
  }
  
  onChangeStatusBuyback() {
    if (!this.formChangeStatus.valid) {
      CommonService.markAsDirty(this.formChangeStatus);
    } else {
      Swal.fire({
        title: 'Update Status Buyback?',
        text: '',
        icon: 'question',
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          this.changeStatus();
        }
      });
    }
  }

  async changeStatus() {
    if (!this.formChangeStatus.valid) {
      CommonService.markAsDirty(this.formChangeStatus);
    } else {
      const payload = {
        ...this.formChangeStatus.value,
        _id: this.buyback._id
      };
      this.isLoading = true;

      await this._BuybackRest
        .changeStatusBuyback(payload)
        .toPromise()
        .then((response: any) => {
          if (!!response?.invalid) {
            Swal.fire({
              icon: 'warning',
              title: 'Change Status Failed',
              confirmButtonText: 'OK'
            });
          } else {
            Swal.fire(
              'Change Status Successfully!',
              '',
              'success'
            )

            this._buybackListComponent.callHookDirectly('init');
            this.closeModal();
          }
        })
        .catch(error => {
          console.log(error)
          Swal.fire(
            'Oops..',
            'Something went wrong!',
            'error'
          )
        });
      this.isLoading = false;
    }
  }
}